import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useLocation } from "react-router-dom";

export default function PageTitle({ entrepriseName }) {
    const { user, apiUrl, fetchRoles, logout, fetchUser } = useContext(AuthContext);
    const location = useLocation();

    const pageTitles = {
        "/": "Dashboard",
        "/tickets": "Tickets",
        "/equipements/cisco": "Équipements Cisco",
        "/equipements/poly": "Équipements Poly",
        "/equipements/evoko": "Équipements Evoko",
        "/equipements/barco": "Équipements Barco",
        "/equipements/hp": "Équipements HP",
        "/equipements/lenovo": "Équipements Lenovo",
        "/smartnet": "Contrats Smartnet",
        "/secure_endpoint/equipement": "Secure Endpoint",
        "/secure_endpoint/events": "Secure Endpoint",
        "/certificats": "Certificats",
        "/webex": "Webex",
        "/dast": "DAST",
        "/hardware": "Hardware",
        "/hardware_visio": "Hardware",
        "/hardware_firewall": "Hardware",
        "/licences/palo": "Licences Palo",
        "/firewall/palo": "Firewall Palo",
        "/firewall/cisco": "Firewall Cisco",
        "/firewall/forti": "Firewall Fortinet",
        "/umbrella": "Umbrella",
        "/meraki": "Meraki",
        "/meraki/licenses": "Licences Meraki",
        "/users": "Utilisateurs",
        "/smart_account": "Smart Account",
        "/visio": "Équipements Visio",
        "/files_manager": "Gestionnaire de fichiers",
        "/microsoft": "Microsoft",
        "/IoT": "IoT",
        "/auvik": "Auvik",
        "/timeline": "Timeline",
        "/statistics": "Statistiques",
        "/parking": "Parking",
        "/agentinsight": "Statistiques des Agents",
        "/logs": "Logs",
        "/securonix": "Securonix",
        "/subscription": "Abonnements",
        "/sentinelone": "SentinelOne",
        "/sentinelOne": "SentinelOne",
        "/cato": "Cato",
        "/liaisonethernet": "Liaison internet",
        "/ubiquiti": "Ubiquiti"
    };

    const extractPath = (pathname) => {
        // Vérifier si le chemin complet existe dans pageTitles
        if (pageTitles[pathname]) {
            return pathname;
        }

        // Sinon, extraire le premier segment du chemin
        const regex = /^\/[^\/]+/;
        const match = pathname.match(regex);
        return match ? match[0] : pathname;
    };

    const simplifiedPath = extractPath(location.pathname);
    const currentTitle = pageTitles[simplifiedPath] || "Page";

    return (
        <div className="container-page-title">
            <span className="container-page-title-text fade-in">{currentTitle}</span>
            {entrepriseName && (
                <>
                    <span className="container-page-title-entreprise fade-in">-</span>
                    <span className="container-page-title-entreprise fade-in">{entrepriseName}</span>
                </>
            )}
        </div>
    );
}